'use client';

import { Button } from '@petsmart-ui/sparky';
import { useState } from 'react';

import { AutoshipInfoDrawer as SharedAutoShipInfoDrawer } from '@libs/shared-ui';

import { dataLayerPush } from '@/shared/analytics';

type AutoShipInfoDrawerProps = {
    discountDisplay?: string;
    isFirstAutoshipEligible: boolean;
};

export const AutoshipInfoDrawer = (props: AutoShipInfoDrawerProps) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const handleDataLayerPushEvent = () => {
        dataLayerPush({
            event: 'view_autoship_info_modal',
            site_section: 'pdp',
        });
    };

    return (
        <>
            <Button
                iconName="info-outline"
                iconSize="sm"
                onClick={() => setIsDrawerOpen(true)}
                title="Autoship Information"
                variant="bare"
                data-testid="autoship-info-drawer-button"
                type="button"
            />
            <SharedAutoShipInfoDrawer
                discountDisplay={props.discountDisplay}
                isFirstAutoshipEligible={props.isFirstAutoshipEligible}
                isDrawerOpen={isDrawerOpen}
                setIsDrawerOpen={setIsDrawerOpen}
                dataLayerPushEvent={handleDataLayerPushEvent}
            />
        </>
    );
};
